import User from '@/core/User';
import Secret from '@/core/Secret';
import Prevent from '@/core/Prevent';
import ResponseHandler from '@/core/ResponseHandler';

//用户数据
const user = new User('user_data');
const system_info = new User('system_info');

//签名钥匙
const signKey: string = 'YdFwDEHE8Xe9uxj7';
//rsa公钥
const rsaPublicKey: string = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDjyMpOxK8VEgFHAcgK1fZT4HoCFjP2ZkLjmxo3G1n0t6/Ak5p4Ec+qi3gdzF8PDghu/k0/IMSCHuMJId8azcAEr9DpaRZoKd5bDSAEGpml/ZqwQBqQHWuMEtB7Ju/jot/0KFdkcxl8UgItZq8jo3vq9RcUyfks8TAATa68tQclIwIDAQAB-----END PUBLIC KEY-----';
//rsa私钥
const rsaPrivateKey: string = '-----BEGIN PRIVATE KEY-----MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAOPIyk7ErxUSAUcByArV9lPgegIWM/ZmQuObGjcbWfS3r8CTmngRz6qLeB3MXw8OCG7+TT8gxIIe4wkh3xrNwASv0OlpFmgp3lsNIAQamaX9mrBAGpAda4wS0Hsm7+Oi3/QoV2RzGXxSAi1mryOje+r1FxTJ+SzxMABNrry1ByUjAgMBAAECgYEA40pxbOXf2sOLmMITTZSw5oNg24IyOZVS+3DCWOim+4TrD9t5UIRdVs0yf3F2DTywd6izheF5lGmjnHI7ALD7/w9LjgxWwMGPAYPkrSKPazvgQWQrhIlqyVByipRLhaHwOrfgvEtICDn4E6YGj5DlZogL8h9+NmMBxqTgYtWWYOECQQDzxTLlqJydDhKtC62LeE9Y6uKgYCQEtYKKtSUoMldcdBaVSCsCuJ7SHyJSyvhAczT/7AN8izkHa9IiuI6QoH8zAkEA7zZHnXRUDa+APvPmqkO6yo0rR+Mhz9yXCM9eIGH56Vi9YjjfNKmmFFyEXZeNmKtJEr/iGP28OeAj6qm8U72CUQJAFMNBGIqJ/F6MfKy39V8j8wDemKZXqwcCvWm8ZnYTNs60dbaV4z9yV5dLRx3+kw68/udNTLhW/SjT1x09F1h0PQJAPtMGo/e1S5LYH7B22CjJmgDRaSPh8XGByTKNCfwxYnOH6Y/+LxqPH7Hcoaf37CywGFiEzQN2t8yCIlNJvsR6wQJARVYs/3+Izt5IZVzjfwQZmGtj99VsT14rdZYlD1XPNZE9it8z5Bs8D5uzUOxGfn6S9qFOAvVBPqQSzoLI3vhAJw==-----END PRIVATE KEY-----';
//数据加密
const secret = new Secret(signKey, rsaPublicKey, rsaPrivateKey);

//阻止重复
const prevent = new Prevent();

//响应处理
const resHandler = new ResponseHandler();

//字符串转换数值数组
function strToNumArray(strArr: string, defArr: number[] = []): number[] {
    if (strArr) {
        return strArr.split(',').map(strNum => Number(strNum));
    }
    return defArr;
}

//账号类型
const ACCOUNT_TYPE = ['custodian', 'court', 'creditor', 'admin'];

export {
    user,
    system_info,
    secret,
    prevent,
    resHandler,
    strToNumArray,
    ACCOUNT_TYPE
};

//声明全局
declare module "vue/types/vue" {
    interface Vue {
        $user: User,
        $system_info: User,
        $prevent: Prevent
    }
}
